import { render, staticRenderFns } from "./TrustRole.vue?vue&type=template&id=6d427e9c&scoped=true"
import script from "./TrustRole.vue?vue&type=script&lang=js"
export * from "./TrustRole.vue?vue&type=script&lang=js"
import style0 from "./TrustRole.vue?vue&type=style&index=0&id=6d427e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d427e9c",
  null
  
)

export default component.exports